import { ObjectMap } from 'mf_core/query';
import { ButtonProps } from '@im/ui-lib/zenith/Button';

export function getWidthOfButton(
  buttonStyles?: ObjectMap,
  buttonProps?: ButtonProps
) {
  if (buttonStyles?.width) return buttonStyles?.width;
  else if (buttonProps?.fullWidth) return buttonProps?.fullWidth;
  else return 'fit-content';
}

export function getRecommendationRecordId(
  recommendationRecordId?: string,
  placementId?: string
) {
  if (recommendationRecordId !== '' && placementId !== '')
    return `${placementId}||${recommendationRecordId ?? ''}`;
  else if (recommendationRecordId === '' && placementId !== '')
    return `${placementId}||Recommendation Id Not Available`;
  else return '';
}
